import {put, select} from 'redux-saga/effects';
import {AppState} from '../../../../../../state/store';
import {setCurrentHtmlInfo as _setCurrentHtmlInfo} from '../state/textViewerSlice';

export function* setCurrentHtmlInfo({productId}: {productId: number}) {
  const {currentChapterId, loadedHtmlInfoList, preloadedHtmlInfoList} =
    yield select((state: AppState) => ({
      currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
      preloadedHtmlInfoList:
        state.textViewer.viewData[productId]?.preloadedHtmlInfoList,
      loadedHtmlInfoList: state.textViewer.viewData[productId]?.htmlInfoList,
    }));
  const currentHtmlInfo =
    loadedHtmlInfoList?.[currentChapterId] ||
    preloadedHtmlInfoList?.[currentChapterId];

  if (currentHtmlInfo) {
    yield put(_setCurrentHtmlInfo({productId, htmlInfo: currentHtmlInfo}));
  }
}
